import { usePostHttp } from "../../http.hook";
import type { IComment } from "./get-proposal-social-comments.admin.http";

interface IBody {
  message: string;
}

interface IResponse {
  comment: IComment;
}
export function useAddProposalSocialCommentsAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/campaigns/proposals/:proposalId/socials/:proposalSocialId/comments",
  });
}
